export const moreButtonLabel = "ZNGkyd";
export const feedbackButtonMenuLabel = "oO33Xc";
export const diagnosticsButtonMenuLabel = "vZp9$b";
export const featureFlagsButtonMenuLabel = "iFSmvc";
export const settingsButtonMenuLabel = "M3FmNd";
export const helpButtonMenuLabel = "UEC3Bd";
export default {moreButtonLabel,feedbackButtonMenuLabel,diagnosticsButtonMenuLabel,featureFlagsButtonMenuLabel,settingsButtonMenuLabel,helpButtonMenuLabel};